
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/advisory-board",
      function () {
        return require("private-next-pages/world/advisory-board.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/advisory-board"])
      });
    }
  